import React, { useState } from "react";
import {
  Layout,
  Card,
  Form,
  Input,
  Button,
  Typography,
  message,
  Modal,
} from "antd";
import { Link, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../constants/Constants";
import Swal from "sweetalert2";
import { FaRegEye, FaEyeSlash } from "react-icons/fa";
const { Content } = Layout;

const ResetPassword = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const history = useHistory();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [email, setEmail] = useState("");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleRecoverPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setPasswordsMatch(false);
      return;
    }
    try {
      const response = await axios.post(
        `${BASE_URL}/users/resetPassword?email=${email}&token=${token}&newPassword=${newPassword}`
      );
      console.log(response);
      message.success("Password reset successful!");
      window.location.href("/login");
    } catch (error) {
      console.error(error.response);
      message.error("Something went wrong! Try again later");
    }
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  return (
    <>
      <div className="layout-default h-[100vh] w-full ant-layout layout-sign-up">
        <Content className="flex m-auto justify-center p-auto w-full">
          <Card
            className="card-signup header-solid h-full ant-card pt-0"
            title={<h5>Reset Password</h5>}
            bordered={false}
          >
            <Form
              name="basic"
              initialValues={{ remember: true }}
              className="row-col"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                ]}
              >
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                />
              </Form.Item>
              <Form.Item
                name="password"
                style={{ position: "relative", cursor: "pointer" }}
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input
                  type={showPassword ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="New Password"
                />
                <div
                  style={{ position: "absolute", right: "3%", top: "20%" }}
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <FaEyeSlash className="field-icon" size={25} />
                  ) : (
                    <FaRegEye className="field-icon" size={25} />
                  )}
                </div>
              </Form.Item>

              <Form.Item
                name="password"
                style={{ position: "relative", cursor: "pointer" }}
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  placeholder="Confirm Password"
                />
                <div
                  style={{ position: "absolute", right: "3%", top: "20%" }}
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {showConfirmPassword ? (
                    <FaEyeSlash className="field-icon" size={25} />
                  ) : (
                    <FaRegEye className="field-icon" size={25} />
                  )}
                </div>
              </Form.Item>
              {!passwordsMatch && (
                <p style={{ color: "red", textAlign: "left", margin: "0" }}>
                  Passwords do not match
                </p>
              )}
              <Form.Item>
                <Button
                  style={{ width: "100%", height: "30px", marginTop: "10px" }}
                  type="primary"
                  size="small"
                  htmlType="submit"
                  onClick={handleRecoverPassword}
                  className="bg-blue-500 hover:bg-blue-700 rounded"
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Content>
      </div>
    </>
  );
};

export default ResetPassword;
